import React from "react";
import { from, BehaviorSubject } from "rxjs";
import { mergeMap, debounceTime, distinctUntilChanged, } from "rxjs/operators";
import { Typography, Dialog, DialogTitle, DialogContent, AppBar, Toolbar, InputBase, Box } from "@material-ui/core";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise/dist/styles/ag-grid.css";
import "ag-grid-enterprise/dist/styles/ag-theme-balham.css";
import "ag-grid-enterprise/dist/styles/ag-theme-balham-dark.css";

import { AuthContext } from "../../../../../shared/store/authProvider";
import { ResultStatus, CrudAction } from "../../../../../shared/types/enums";
import { DataService, SubscriptionArray } from "../../../../../shared/services/dataService";
import LayoutService from "../../../../../shared/services/layoutService";

import ActionDialog from "../../../../../shared/components/dialog/actionDialog";
import PageLoadingComponent from "../../../../../shared/components/page/pageLoadingComponent";
import DialogErrorFragmentComponent from "../../../../../shared/components/page/dialogErrorFragmentComponent";
import { MatIconService } from "../../../../../shared/services/theme/matIconService";
import RelatedTransactionsSearchDialogService from "./realtedTransactionsSearchDialogService";
import AgGridRadioButtonCellRendererComponent from "../../../../../shared/components/elements/agGridRadioButtonCellRendererComponent";
import { AgGridUtil } from "../../../../../shared/services/ag-grid/agGridUtil";

import TransactionDetailDialogComponent from "../../../transaction-detail/transactionDetailDialogComponent";
import ChildMessageRendererComponent from "../../../childMessageRendererComponent";
import ToastService from "../../../../../shared/services/toastService";


class RelatedTransactionsSearchDialogComponent extends React.Component {

    static contextType = AuthContext;

    // ept till component's unMount
    scopedSubscriptions = new SubscriptionArray();
    // apiSubscriptions are canclled before retry also
    apiSubscriptions = new SubscriptionArray();

    constructor(props) {
        super(props);

        // init state
        this.state = {
            searchResult: ResultStatus.NOT_LOADED,
            transactionList: [],
            selectedTransaction: null,
            lastSearchedValue: '',
            errorMessage: null,
            showTransactionDetailDialog: false,
            showLinkWarningDialog: false,
            agGridRecipientUtils: new AgGridUtil("lastName", {
                isSelectedCellRenderer: AgGridRadioButtonCellRendererComponent,
                childMessageRendererComponent: ChildMessageRendererComponent,
            }),
        };
    }

    componentWillUnmount() {
        this.scopedSubscriptions.cancelAll();
        this.apiSubscriptions.cancelAll();
    }

    searchSubject = new BehaviorSubject("");

    componentDidMount() {
        var searchOBS = this.searchSubject.pipe(
            debounceTime(750),
            distinctUntilChanged(),
            mergeMap((_searchValue) => from(this.searchTransaction(_searchValue)))
        );

        this.scopedSubscriptions.add(searchOBS.subscribe());
    }

    // called on row-cell click
    methodFromParent = (row_col, node) => {
        node.transactionid = node.trid;
        this.setState({ modalAgNode: { ...node, porziogsttransactionid: node.porzioGstTransactionId, transactionid: node.trid, sourceid: node.sourceId } }, () => {
            this.setState({ showTransactionDetailDialog: true });
        });
    };

    formatDateToYYYYMMDD = (_date) => {
        let date = new Date(_date);
        return date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, '0') + "-" + String(date.getDate()).padStart(2, '0');
    }

    searchTransaction = (_searchValue) => {
        this.apiSubscriptions.cancelAll();

        if (DataService.stringShouldBe(_searchValue, 3)) {
            this.setState({ searchResult: ResultStatus.LOADING, transactionList: [], selectedTransaction: null, lastSearchedValue: _searchValue });
            this.apiSubscriptions.add(
                RelatedTransactionsSearchDialogService.searchOBS(this.context.user.tenantId, _searchValue).subscribe(
                    (_transactionListMain) => {
                        if (DataService.hasElements(_transactionListMain)) {
                           var _transactionList = _transactionListMain.filter(x => x.porzioGstTransactionId!==this.props.loadedTransaction && x.transactionDate === this.formatDateToYYYYMMDD(this.props.transactionDate));
                            _transactionList.forEach(x => { x.isSelected = false; });
                        }
                        this.setState({
                            searchResult: DataService.hasElements(_transactionList) ? ResultStatus.SUCCESS : ResultStatus.LOADED,//-> no records
                            transactionList: _transactionList,
                        });
                    },
                    (err) => { this.setState({ searchResult: ResultStatus.ERROR }); }
                )
            );
        } else {
            this.setState({ searchResult: ResultStatus.NOT_LOADED });
        }
        return [];
    }

    buildSelectedTransactionObj = (_selectedTransaction) => {
        let currentLinkedTransactionsIds = this.props.currentLinkedTransactions.map(x => x.PorzioTransactionId);
        if (currentLinkedTransactionsIds.includes(_selectedTransaction.porzioGstTransactionId))
            ToastService.showError("Selected transaction is already linked.");
        else {
            _selectedTransaction.CompanyTransactionId = _selectedTransaction.companyTransactionId;
            _selectedTransaction.PorzioTransactionId = _selectedTransaction.porzioGstTransactionId;
            _selectedTransaction.LastName = _selectedTransaction.lastName;
            _selectedTransaction.FirstName = _selectedTransaction.firstName;
            _selectedTransaction.OrganizationName = _selectedTransaction.organizationName;
            _selectedTransaction.CountryName = _selectedTransaction.country;
            _selectedTransaction.isSelected = false;
            this.props.onClose(_selectedTransaction);
        }
    }

    // render
    render() {
        const { classes } = this.props;
        return (
            <Dialog open={this.props.open || false} fullWidth={true} maxWidth='lg' scroll={false ? "paper" : "body"}>
                <DialogTitle style={{ padding: 0 }} id="dialog-title">
                    <AppBar position="static">
                        <Toolbar>
                            <Typography variant="h6" className={classes.root}>Transaction Search</Typography>
                            {/* Search */}
                            <div className={classes.search}>
                                <div className={classes.searchIcon}>{MatIconService.SEARCH}</div>
                                <InputBase autoFocus={true} placeholder="Search…" classes={{ root: classes.inputRoot, input: classes.inputInput }} inputProps={{ "aria-label": "search" }}
                                    onChange={(e) => { this.searchSubject.next(e.target.value); }} />
                            </div>
                            {LayoutService.getIconButton(DataService.isNullOrUndefined(this.state.selectedTransaction), MatIconService.LINK, "Link", () => {
                                this.props.currentLinkedTransactions.includes(this.state.selectedTransaction.porziogsttransactionid) ?
                                    this.setState({ showLinkWarningDialog: true }) : this.buildSelectedTransactionObj(this.state.selectedTransaction);
                            }, "inherit", "keyActionSave")}
                            {/* {LayoutService.getIconButton(false, MatIconService.OK, "Submit", () => { alert("Under development") }, "inherit")} */}
                            {/* {LayoutService.getIconButton(false, MatIconService.IDEA_BULB_32, "Possible Matches", () => { alert("Under development") }, "inherit")} */}
                            {LayoutService.getIconButton(false, MatIconService.CANCEL, "Cancel", () => { this.props.onClose("", "") }, "secondary", "keyActionCancel1")}
                        </Toolbar>
                    </AppBar>
                </DialogTitle>
                <DialogContent>
                    <Box style={{ paddingLeft: 16, paddingRight: 32, paddingTop: 8, paddingBottom: 32, minHeight: "60vh", maxHeight: "60vh" }}>
                        {this.renderContent(classes)}
                    </Box>
                </DialogContent>
                {!this.state.showTransactionDetailDialog ? null : <TransactionDetailDialogComponent fromGlobalSearch={true} inputAction={CrudAction.UPDATE} modalAgNode={this.state.modalAgNode}
                    open={this.state.showTransactionDetailDialog || false} onClose={() => { this.setState({ showTransactionDetailDialog: false }); /*this.fetchData(true);*/ }} />}
                <ActionDialog showDialog={this.state.showLinkWarningDialog} title="Transaction link exists" description={"Selected Transaction is already linked with " + this.props.loadedTransaction}
                    actions={[
                        {
                            color: "inherit", text: "Cancel", icon: null,
                            callback: () => { this.setState({ showLinkWarningDialog: false }, () => { }) }
                        }
                    ]} />
            </Dialog >
        );
    }

    renderContent = (classes) => {
        switch (this.state.searchResult) {
            case ResultStatus.SAVING: return <PageLoadingComponent small classes={classes} label="Saving..." />;
            case ResultStatus.LOADING: return <PageLoadingComponent small classes={classes} label="Searching..." />;
            case ResultStatus.NOT_LOADED: return <DialogErrorFragmentComponent small classes={classes} description="Please enter atleast 3 characters to search" />;
            case ResultStatus.LOADED: return <DialogErrorFragmentComponent small classes={classes} description="No Records Found" />;
            case ResultStatus.SUCCESS:
                return (<div id="MainRoleGrid">
                    <div style={{ height: `59vh`, width: `100%` }} {...LayoutService.getAgGridTheme()}>
                        <AgGridReact
                            rowData={this.state.transactionList}
                            columnDefs={RelatedTransactionsSearchDialogService.getColumnDefs(this, (_data) => {
                                this.setState({ selectedTransaction: _data });
                            })}
                            suppressClickEdit={true}
                            frameworkComponents={this.state.agGridRecipientUtils.frameworkComponents}
                            onGridReady={(params) => { this.state.agGridRecipientUtils.setGridParams(params, true); }}
                            gridOptions={{
                                context: { componentParent: this },
                                suppressContextMenu: true,
                                rowHeight: 32,
                            }}
                        />
                    </div>
                </div>);
            case ResultStatus.ERROR:
            default:
                return (<DialogErrorFragmentComponent classes={classes} description="An error occured while Searching" onRetry={() => { this.searchTransaction(this.state.lastSearchedValue); }} />);
        }
    }

}
export default LayoutService.getHocComponenet(RelatedTransactionsSearchDialogComponent);